import React from "react";
import FlatButton from "./FlatButton";
import RaisedButton from "./RaisedButton";

class AddAnnotationPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = { newAnnotationText: "", newAnnotationType: "" };

    this.onTextChange = this.onTextChange.bind(this);
    this.onTypeChange = this.onTypeChange.bind(this);
  }

  onTextChange(event) {
    const old = this.state.newAnnotationText;

    if (old.length < 250 || old.length > event.target.value.length)
      this.setState({ newAnnotationText: event.target.value });
  }

  onTypeChange(event) {
    this.setState({ newAnnotationType: event.target.value });
  }

  onSubmit() {
    this.props.addNewAnnotation({
      text: this.state.newAnnotationText,
      type: this.state.newAnnotationType
    });
    this.props.onHide();
  }

  onDismiss() {
    this.props.onHide();
  }

  render() {
    return (
      <div className="PanelAddAnnotation">
        <div className="InnerPanel">
          <p>Deine Anmerkung</p>
          <textarea
            value={this.state.newAnnotationText}
            onChange={this.onTextChange}
            placeholder="Schreibe was dir dazu einfällt..."
          />
          <p className="Float-Right">{`${
            this.state.newAnnotationText.length
          }/250`}</p>
          <br />
          <br />
          <p>Wie findest du das?</p>
          <label className="RadioContainer">
            Gut
            <input
              type="radio"
              name="annoRadio"
              value="good"
              checked={this.state.newAnnotationType === "good"}
              onChange={this.onTypeChange}
            />
            <span className="checkmark" />
          </label>
          <label className="RadioContainer">
            Schlecht
            <input
              type="radio"
              name="annoRadio"
              value="bad"
              checked={this.state.newAnnotationType === "bad"}
              onChange={this.onTypeChange}
            />
            <span className="checkmark" />
          </label>
          <br />
          <span>
            <FlatButton label="Verwerfen" onClick={() => this.onDismiss()} />
            <RaisedButton
              onClick={() => this.onSubmit()}
              label="Speichern"
              disabled={
                this.state.newAnnotationText.trim().length < 5 ||
                (this.state.newAnnotationType !== "good" &&
                  this.state.newAnnotationType !== "bad")
              }
            />
          </span>
        </div>
      </div>
    );
  }
}

export default AddAnnotationPanel;



// WEBPACK FOOTER //
// ./src/components/AddAnnotationPanel.js